// apps/client/src/audio/titleScore.ts (title screen, 2026-10-05) — the title theme: an original tune for the same band as the town loop
// (D-02, audio/score.ts), played from Play now through sign-in, the creator, the towns list and the loading screen. Written here note
// by note, so it is original by construction: D major, unhurried, a music box stating the tune, a flute answering, then a section of
// glockenspiel fills, with one borrowed minor bar (Gm6) for the wistful turn before home.
import type { Chord, Mood, Note, Score } from './score';

// Dmaj9 | Gmaj9 | F#m7 Bm9 | Em9 A13sus4 | Dmaj9 | Bm9 E9 | Gm6 | Em9 A13
export const TITLE_CHORDS: readonly Chord[] = [
  { at: 0, len: 4, voicing: [54, 57, 61, 64], root: 38 },
  { at: 4, len: 4, voicing: [54, 57, 59, 62], root: 43 },
  { at: 8, len: 2, voicing: [52, 57, 61, 66], root: 42 },
  { at: 10, len: 2, voicing: [50, 54, 57, 61], root: 47 },
  { at: 12, len: 2, voicing: [55, 59, 62, 66], root: 40 },
  { at: 14, len: 2, voicing: [55, 59, 62, 64], root: 45 },
  { at: 16, len: 4, voicing: [54, 57, 61, 64], root: 38 },
  { at: 20, len: 2, voicing: [50, 54, 57, 61], root: 47 },
  { at: 22, len: 2, voicing: [56, 59, 62, 66], root: 40 },
  { at: 24, len: 4, voicing: [52, 55, 58, 62], root: 43 },
  { at: 28, len: 2, voicing: [55, 59, 62, 66], root: 40 },
  { at: 30, len: 2, voicing: [55, 61, 64, 66], root: 45 },
];
// The tune (music box): it climbs to the top of the second bar, settles, and asks its question over the Gm6.
export const TITLE_THEME: readonly Note[] = [
  [0, 1.5, 76], [1.5, 0.5, 74], [2, 1, 73], [3, 1, 69],
  [4, 1.5, 71], [5.5, 0.5, 74], [6, 2, 78],
  [8, 1, 76], [9, 1, 73], [10, 1, 74], [11, 1, 73],
  [12, 1.5, 71], [13.5, 0.5, 74], [14, 2, 76],
  [16, 1, 81], [17, 1, 78], [18, 0.5, 76], [18.5, 0.5, 78], [19, 1, 81],
  [20, 1.5, 78], [21.5, 0.5, 76], [22, 1, 80], [23, 1, 78],
  [24, 2, 79], [26, 1, 76], [27, 1, 74],
  [28, 1, 71], [29, 1, 74], [30, 2, 73],
];
// The answer (flute), lower and more lyrical, with the B♭ of the borrowed bar.
export const TITLE_ANSWER: readonly Note[] = [
  [0, 2, 69], [2, 1, 73], [3, 1, 76],
  [4, 3, 74], [7, 1, 71],
  [8, 1, 69], [9, 1, 73], [10, 1.5, 73], [11.5, 0.5, 74],
  [12, 2, 71], [14, 1, 74], [15, 1, 76],
  [16, 1.5, 78], [17.5, 0.5, 76], [18, 2, 73],
  [20, 1, 74], [21, 1, 73], [22, 2, 71],
  [24, 1, 70], [25, 1, 74], [26, 2, 76],
  [28, 1, 74], [29, 1, 71], [30, 1, 73], [31, 1, 69],
];
/** One mood for the whole theme: unhurried, the comping and bass a touch softer than the town's, a brushed shaker and a soft kick. */
export const TITLE_MOODS: readonly Mood[] = [
  { bpm: 82, lead: 'musicbox', shift: 0, ep: 0.8, bass: 0.8, shaker: 0.35, rim: 0, kick: 0.3 },
];
export const TITLE_SCORE: Score = {
  chords: TITLE_CHORDS, sections: [TITLE_THEME, TITLE_ANSWER, null], leads: ['musicbox', 'flute', 'glock'], length: 32,
};
